<template>
  <v-dialog v-model="visible" max-width="641" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">
          {{ $t(`${namespace}.deleteChargebackOnRace`) }} #{{ data.receipt.corporateJob.apiInfo.apiTaxiJobId }}
        </span>

        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        v-if="isValidObject(data)"
        class="px-4 pt-0 pb-5"
        v-html="
          $t(`${namespace}.deleteChargebackConfirmMessage`)
            .replace('[RIDE_VALUE]', `<strong>${convertToCurrencyBRL(data.chargeBack.value)}</strong>`)
            .replace('[RIDE_DATE]', `<strong>${moment(data.receipt.corporateJob.start.date).format('DD/MM/YYYY')}</strong>`)
        "
      />

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="accent"
          depressed
          round
          @click.native="cancelChargeBack"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isObject, isArray, convertToCurrencyBRL } from 'utils/functions'

export default {
  name: 'DeleteChargebackDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.FinancialAdjustmentsPage',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    isValidArray (val) {
      return isArray()
    },

    convertToCurrencyBRL (val) {
      return convertToCurrencyBRL(val)
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async cancelChargeBack () {
      this.isLoading = true

      try {
        const message = this.$t(`${this.namespace}.deleteChargebackSuccess`)
          .replace('[RIDE_VALUE]', convertToCurrencyBRL(this.data.chargeBack.value))
          .replace('[RIDE_ID]', this.data.receipt.corporateJob.apiInfo.apiTaxiJobId)

        const chargeBackId = this.data.chargeBack.id

        const { data: res } = await this.$apiService.cancelChargeBack(chargeBackId, {
          reason: 'Cancelamento de estorno'
        })

        if (res && !res.valid) {
          const error = this.isValidArray(res.reasons) ? res.reasons[0] : res.message
          this.showAlert({
            type: 'error',
            message: error || this.$t(`${this.namespace}.deleteChargebackError`)
          })
        } else {
          this.showAlert({ type: 'success', message })
          this.close(true)
        }
      } catch (error) {
        console.log('ERROR:', error)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.deleteChargebackError`)
        })
      }

      this.isLoading = false
    }
  }
}
</script>
